import styled from 'styled-components';

export const ContainerHeaderSindico = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;

  padding-top: 24px;

  .info-container {
    width: 1172px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 48px;
    padding: 0 2px;

    p {
      font-size: 24px;
      line-height: 32px;
      font-weight: 400;
      margin: 0;
      color: #4d4d4d;
    }

    .section-title {
      margin-bottom: 32px;
      .title-home-sindico {
        margin: 0;
        color: ${({ tema }) => tema.primaryColor};
        font-size: 48px;
        font-weight: 600;
        display: block;
        line-height: 60px; /* 125% */
        letter-spacing: -0.96px;
      }
      .subtitle-home-sindico {
        font-size: 28px;
        line-height: 32px;
        color: ${({ tema }) => tema.primaryColor};
        margin-top: 8px;
      }
    }
  }

  .diana-img-home-sindico {
    width: 460px;
  }

  @media (max-width: 1200px) {
    padding-top: 60px;
    .info-container {
      text-align: center;
      width: 97vw;
      flex-direction: column;

      p {
        font-size: 20px;
        line-height: 30px;
      }

      .section-title {
        .title-home-sindico {
          font-size: 28px;
          line-height: 32px;
        }
        .subtitle-home-sindico {
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
    .diana-img-home-sindico {
      width: 280px;
    }
  }

  @media (max-width: 767px) {
    margin-top: 40px;
    padding-top: 80px;
  }
`;
export const BodyHomeSindico = styled.div`
  background-color: transparent;
  margin-top: 60px;
  width: 1172px;
  margin: 60px auto;
  display: flex;
  flex-direction: column;
  gap: 60px;

  @media (max-width: 1200px) {
    margin-top: 40px;
    width: 97vw;
    gap: 24px;
  }
`;
